export const TRANSLATION_SCOPE = 'questionnaireSubmissionModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_TABLE_EXPORT_SCOPE = [TRANSLATION_SCOPE, 'tableExport'];
